import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTransaction } from './hooks/useTransaction';
import { canPlay } from 'containers/Player/utils/PlayRules';
import {
  setKeywordSearch,
  setLiveMenuOptions,
} from 'containers/NewSearchPage/redux/actions/searchActions';
import { getRegion } from 'utils/Region';
import { isFutureEvent } from './utils';
import { checkIfChannelIsBlocked } from 'containers/EPG/actions/channelBlocker/blocker.actions';
import buttonOptionClick from 'containers/Player/actions/optionButtons/optionButtons.actions';
import { getContentInfoLive } from '../../utils/getDataFromLiveVodContent';
//---------------------------------------------------------------------------------------
import { PosterCard } from './components/PosterCard';
import { DetailsCard } from './components/DetailsCard';
import { getChannelFromEpg } from './../../utils/getChannelFromEpg';
import './style.scss';
import { pushEventFromSearchCard } from 'containers/NewSearchPage/utils/pushEventsFromSearch';
import {
  EPG_SET_CURRENT_CHANNEL,
  SET_EVENT_FROM_EPG,
} from 'containers/Player/actions/liveMenu/constants';
import { useGetEventFromEpg } from './hooks/useGetEventFromEpg';
import Utils from 'utils/Utils';
import ClaroUrlBuilder from 'utils/ClaroUrlBuilder';
import { useHandlePlayContent } from './hooks/useHandlePlayContent';
import { useNavigate } from 'react-router-dom';

//Este componente muestra la card del contenido del resultado de una busqueda
const SearchResultCard = ({ contentInfo, value, isPopularSearch }) => {
  const infinite = useSelector(state => state.linealChannel?.data);
  const dispatch = useDispatch();
  const { openTransaction } = useTransaction();
  const infoGeneral = getContentInfoLive(contentInfo);
  const adapterRes = contentInfo?.content_type || contentInfo?.type;
  const { eventFromEpg } = useGetEventFromEpg({ contentInfo });
  const { handleFutureEvent } = useHandlePlayContent();
  const navigate = useNavigate();

  //Redirecciona a la pantalla correspondiente segun contenido
  const handleRedirectClick = e => {
    e.stopPropagation();
    pushEventFromSearchCard(isPopularSearch, contentInfo, infoGeneral);

    switch (adapterRes) {
      case 'S':
      case 'P':
        navigate(
          `/${getRegion()}/vcard/homeuser/${contentInfo?.title_uri}/${
            contentInfo?.id
          }`,
        );

        //SETEAR EL KEYWORD CONTENIDO VOD SIN PERMISO DE REPRODUCCION
        dispatch(setKeywordSearch(value));
        break;
      case 'E':
      case 'L':
        if (!canPlay(infoGeneral.id, infinite)) {
          //CANAL SIN PERMISO DE REPRODUCCION -> TRANSACCIONES
          openTransaction({
            groupId: infoGeneral.id,
            groupData: contentInfo?.channel_group?.common,
          });
        } else if (
          canPlay(infoGeneral.id, infinite) &&
          isFutureEvent(infoGeneral.begintime)
        ) {
          handleFutureEvent(infoGeneral?.id, eventFromEpg, contentInfo);
        }

        //SETEAR EL KEYWORD PARA EVENTOS FUTUROS
        dispatch(setKeywordSearch(value));
      default:
        break;
    }
  };

  return (
    <div
      className="search-result-card"
      data-testid={`result-${contentInfo.id}`}
    >
      <div
        className="search-result-card__container"
        onClick={handleRedirectClick}
      >
        <PosterCard contentInfo={contentInfo} />
        <DetailsCard value={value} contentInfo={contentInfo} />
      </div>
    </div>
  );
};

SearchResultCard.propTypes = {
  contentInfo: PropTypes.object.isRequired,
};

export default SearchResultCard;
